/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import { BulletList } from 'react-content-loader'

import '../ShopList/list.scss'

import { useNavigate } from 'react-router-dom'

export default function index(data) {
  const [codes, setCodes] = useState([])
  const navigate = useNavigate()

  if (codes.enDate !== undefined) {
    console.log(JSON.parse(codes.enDate))
  }
  useEffect(() => {
    setCodes(data.data)
  }, [data])

  return (
    <>
      <table className='table'>
        <thead>
          <tr>
            <th>نام کد</th>
            <th>درصد تخفیف</th>
            <th>زمان اتمام تخفیف</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {codes ? codes.map(item => (
              <tr key={item._id}>
                <td>{item.code}</td>
                <td>{item.percent}</td>
                <td>{`${item.enDate.year}/${item.enDate.month}/${item.enDate.day}`}</td>
                <td>
                  <button onClick={() => navigate(`/offs/edit/${item._id}`)}>ویرایش</button>
                </td>
              </tr>
            )) : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
        </tbody>
      </table>
    </>
  );
}
